import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FilterBlog from "../components/FilterBlog";
import { fetchBlogs } from "../features/blogs/blogsSlice";
import Blog from "../components/Blog";

export default function Home() {
  const dispatch = useDispatch();
  const { blogs, isLoading } = useSelector((state) => state.blogs);
  const { sortValue, filterType } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchBlogs());
  }, [dispatch]);

  return (
    <section className="wrapper">
      <FilterBlog />
      <main className="post-container" id="lws-postContainer">
        {isLoading
          ? "Loading..."
          : blogs?.length > 0
          ? blogs
              ?.filter((blog) => {
                if (filterType === "saved") {
                  return blog.isSaved;
                } else {
                  return blog;
                }
              })
              ?.map((blog) => <Blog key={blog.id} blog={blog} />)
              ?.sort((a, b) => {
                if (sortValue === "newest") {
                  return (
                    new Date(b.props.blog.createdAt) -
                    new Date(a.props.blog.createdAt)
                  );
                } else if (sortValue === "most_liked") {
                  return b.props.blog.likes - a.props.blog.likes;
                } else {
                  return 0;
                }
              })
          : "No blogs found."}
      </main>
    </section>
  );
}
